var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('aside',[_c('Sidebar')],1),_c('section',[_c('transition',{attrs:{"name":"main","duration":{ leave: 800 }}},[_c('router-view')],1)],1),_c('Player')],1)}
var staticRenderFns = []

export { render, staticRenderFns }